if (undefined === $) {
    if (window.jQuery) {
        $ = window.jQuery;
    } else if (window.Checkout && window.Checkout.$) {
        $ = window.Checkout.$;
    }
}

let isSetTimeoutForCheckServiceCorrectQuantityInCart = false,
    timeoutForCheckServiceCorrectQuantityInCart = null,
    timeoutForCheckServiceCorrectQuantityInCartCounter = 0;
const CheckServiceCorrectQuantityInCart = () => {
    if (timeoutForCheckServiceCorrectQuantityInCartCounter >= 60) {
        window.location.reload();
        return;
    }
    let simpleCartObject,
        updatesObject;

    const setSimpleCartObjectServices = (simpleCartObject, item, parentVariantId) => {
        if (!(parentVariantId in simpleCartObject.products)) {
            simpleCartObject.products[parentVariantId] = {'services': {}};
        }
        if (!('services' in simpleCartObject.products[parentVariantId])) {
            simpleCartObject.products[parentVariantId]['services'] = {};
        }
        simpleCartObject.products[parentVariantId]['services'][item.key] = item.quantity;

        return simpleCartObject;
    };

    const setSimpleCartObjectProducts = (simpleCartObject, item, variantId) => {
        if (!(variantId in simpleCartObject.products)) {
            simpleCartObject.products[variantId] = {};
        }
        if (!('items_count' in simpleCartObject.products[variantId])) {
            simpleCartObject.products[variantId]['items_count'] = 0;
        }
        simpleCartObject.products[variantId]['items_count'] += item.quantity;

        return simpleCartObject;
    };

    if (location.pathname.startsWith('/cart') && !cartLoaderObject.is(':visible').length) {
        cartLoaderObject.show();
    }
    clearTimeout(timeoutForCheckServiceCorrectQuantityInCart);
    fetch('/cart.json')
        .then(response => response.json())
        .then(cartJSON => {
            if (cartJSON.items.length) {
                simpleCartObject = {
                    'products': {},
                    'services': {},
                };
                for (const item of cartJSON.items) {
                    if (!item.handle) {
                        console.log('setTimeout CheckServiceCorrectQuantityInCart()', [...cartJSON.items]);
                        isSetTimeoutForCheckServiceCorrectQuantityInCart = true;
                        timeoutForCheckServiceCorrectQuantityInCart =
                            setTimeout(CheckServiceCorrectQuantityInCart, 1000);
                        timeoutForCheckServiceCorrectQuantityInCartCounter++;
                        return;
                    }
                    if (item.handle == Shopify.theme_settings.cart_services_handle) {
                        simpleCartObject.services[item.key] = item.quantity;
                    } else if (item.properties) {
                        const itemParentVariantId = item.properties['parent_variant_id'] ||
                            item.properties['_parent_variant_id'];
                        const itemPairedProduct = item.properties['paired-product'] ||
                            item.properties['_paired-product'];
                        if (itemParentVariantId) {
                            simpleCartObject = setSimpleCartObjectServices(
                                simpleCartObject,
                                item,
                                itemParentVariantId,
                            );
                        } else if (itemPairedProduct) {
                            simpleCartObject = setSimpleCartObjectServices(
                                simpleCartObject,
                                item,
                                itemPairedProduct,
                            );
                        } else {
                            simpleCartObject = setSimpleCartObjectProducts(simpleCartObject, item, item.variant_id);
                        }
                    } else {
                        if (item.variant_id in simpleCartObject.products) {
                            simpleCartObject = setSimpleCartObjectProducts(simpleCartObject, item, item.variant_id);
                        } else {
                            simpleCartObject.products[item.variant_id] = {items_count: item.quantity};
                        }
                    }
                }

                timeoutForCheckServiceCorrectQuantityInCartCounter = 0;
                if (simpleCartObject) {
                    updatesObject = {};
                    if (!$.isEmptyObject(simpleCartObject.services)) {
                        Object.entries(simpleCartObject.services).forEach(([key, quantity]) => {
                            if (quantity != 1) {
                                updatesObject[key] = 1;
                            }
                        });
                    }
                    if (!$.isEmptyObject(simpleCartObject.products)) {
                        Object.entries(simpleCartObject.products).forEach(([variant_id, item]) => {
                            if (item['services']) {
                                Object.entries(item.services).forEach(([serviceKey, serviceQuantity]) => {
                                    if (serviceQuantity != item.items_count) {
                                        updatesObject[serviceKey] = item.items_count;
                                    }
                                });
                            }
                        });
                    }

                    console.log('simpleCartObject:', simpleCartObject);
                    console.log('updatesObject', updatesObject);
                    if (!$.isEmptyObject(updatesObject)) {
                        fetch('/cart/update.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({ updates: updatesObject })
                        })
                            .then(response => response.json())
                            .then(cartJSON => {
                                CartJS.cart = cartJSON;
                                Shopify.theme.updateSubtotal(CartJS.cart);
                                if (insiacareCompleted) {
                                    cartLoaderObject.hide();
                                }
                            })
                            .catch(function(err) {
                                console.log('Fetch Error : ', err);
                            });
                        isSetTimeoutForCheckServiceCorrectQuantityInCart = false;
                    } else if (insiacareCompleted) {
                        cartLoaderObject.hide();
                    }
                    if (isSetTimeoutForCheckServiceCorrectQuantityInCart) {
                        isSetTimeoutForCheckServiceCorrectQuantityInCart = false;
                        Shopify.theme.updateSubtotal(cartJSON);
                    }
                } else {
                    $(document).trigger('cart.empty');
                }
            } else {
                localStorage.removeItem('_o_insiacare_cart');
                cartLoaderObject.hide();
            }
        })
        .catch(function(err) {
            console.log('Fetch Error : ', err);
        });
};

$(() => {
    CheckServiceCorrectQuantityInCart();
});
$(document).on('cart.requestComplete', (event, cart) => {
    $(document).trigger('cart.allRequestsComplete', cart);
    Shopify.updateItemCount(cart);
});
$(document).on('cart.empty', () => {
    CookiesHelper.removeItem('setCartServices');
    CookiesHelper.removeItem('manualyRemovedCartServices');
    cartLoaderObject.hide();
    console.log('cart.empty');
    if (!$('.cart__empty-cart-message').is(":visible")) {
        console.log('so let\'s truncate cart and animate page empty cart');
        localStorage.removeItem('_o_insiacare_cart');
        CartJS.clear();
        CartJS.clearAttributes();
        $('[data-cart-service]:checked').removeAttr('checked');
        $('.header-cart.action-area__link').removeClass('has-cart-count');
        if ((typeof checkCartAndWishlistCount) === 'function') {
            checkCartAndWishlistCount();
        }
        $('.cart__form').hide({ duration: 'fast', complete: () => { $('.cart__form').remove(); }});
        $('.cart__empty-cart-message').css('display', 'none').removeClass('is-hidden').show('slow');
        requestStartedWithoutLoader = true;
    }
});

let cartLoaderObject = $('');
if (location.pathname.startsWith('/products')
        || location.pathname.startsWith('/collections')
        || location.pathname.startsWith('/search')) {
    let cartLoaderDiv = `<div class="loading" id="cart-loader">
            <div class="loader boost-loader"></div>
        </div>`;
    cartLoaderObject = $(cartLoaderDiv);
    cartLoaderObject.hide();
    cartLoaderObject.appendTo('body');
}
if (location.pathname.startsWith('/cart')) {
    const cartLoaderDiv = '<div class="loading" id="cart-loader">' +
        '<div class="loader boost-loader"></div>' +
        '</div>';
    cartLoaderObject = $(cartLoaderDiv);
    cartLoaderObject.appendTo('body');
    $(() => {
        console.log('currentItemsInCart', currentItemsInCart, !currentItemsInCart);
        window.history.pushState({}, document.title, window.location.pathname);
        $(document).on('cart.ready', () => {
            let oldServicesInCartToRemove = {},
                insuranceVariantsInStorage = JSON.parse(localStorage.getItem('_o_insiacare_cart')) || [],
                insuranceVariantsInStorageNew = [],
                insuranceVariantsInCart = [],
                insurancePairedVariants = {},
                productVariantsInCartList = [];
            for (const cartItem of CartJS.cart.items) {
                console.log('oldServiceInCart', cartItem.key, cartItem.properties);
                if ('properties' in cartItem) {
                    const itemUniqueServiceId = cartItem.properties['unique_service_id'] ||
                        cartItem.properties['_unique_service_id'];
                    const itemPairedProduct = cartItem.properties['paired-product'] ||
                        cartItem.properties['_paired-product'];
                    if (itemUniqueServiceId) {
                        oldServicesInCartToRemove[cartItem.key] = 0;
                    } else if (itemPairedProduct) {
                        insuranceVariantsInCart.push(cartItem.id);
                        insurancePairedVariants[itemPairedProduct] = cartItem.id;
                    } else {
                        productVariantsInCartList.push(cartItem.id);
                    }
                }
            }
            console.log('productVariantsInCartList', productVariantsInCartList);
            console.log('insurancePairedVariants', insurancePairedVariants);
            console.log('insuranceVariantsInCart', insuranceVariantsInCart);
            console.log('insuranceVariantsInStorage', insuranceVariantsInStorage);
            if (insuranceVariantsInStorage.length !== insuranceVariantsInCart.length || insiacareInsuranceEnabled) {
                for (const insuranceVariantInStorage of insuranceVariantsInStorage) {
                    console.log('insuranceVariant checking', insuranceVariantInStorage);
                    if (!insiacareInsuranceEnabled &&
                        insuranceVariantsInCart.includes(insuranceVariantInStorage.insuranceProductVariantId)
                    ) {
                        console.log('insuranceVariant included');
                        insuranceVariantsInStorageNew.push(insuranceVariantInStorage);
                        delete insurancePairedVariants[insuranceVariantInStorage.productVariantId];
                    } else if (insiacareInsuranceEnabled) {
                        if (!productVariantsInCartList.includes(insuranceVariantInStorage.productVariantId)) {
                            console.log('insuranceVariant paired product not included');
                            oldServicesInCartToRemove[insuranceVariantInStorage.insuranceProductVariantId] = 0;
                        } else {
                            console.log('insuranceVariant paired product included');
                            insuranceVariantsInStorageNew.push(insuranceVariantInStorage);
                        }
                        delete insurancePairedVariants[insuranceVariantInStorage.productVariantId];
                    }
                }
                localStorage.setItem('_o_insiacare_cart', JSON.stringify(insuranceVariantsInStorageNew));
            }
            if (insuranceVariantsInCart.length && !insiacareInsuranceEnabled) {
                for (const insuranceVariantToRemove of insuranceVariantsInCart) {
                    oldServicesInCartToRemove[insuranceVariantToRemove] = 0;
                }
                localStorage.removeItem('_o_insiacare_cart');
            }
            console.log('insurancePairedVariants after', insurancePairedVariants);
            console.log('insuranceVariantsInStorageNew', insuranceVariantsInStorageNew);
            if (Object.keys(oldServicesInCartToRemove).length > 0) {
                console.log('oldServicesInCartToRemove', oldServicesInCartToRemove);
                cartLoaderObject.show();
                $.post('/cart/update.js', {updates: oldServicesInCartToRemove},
                    (cartJSON) => {
                        CartJS.cart = cartJSON;
                        cartLoaderObject.hide();
                        Shopify.theme.updateSubtotal(CartJS.cart);
                    },
                    'json'
                );
            }
        });
    });
}
